
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CancellationAccountForm,
  CustomerNotificationPreferences,
  FreelancerNotificationPreferences,
  Identity,
  IdentityRequest,
  NewEmailForm,
  PasswordChangeForm,
  PersonalInformation,
  PersonalInformationRequest,
  Phone,
  PhoneRequest,
  PhoneValidationStatus,
  ProfilePrivacyPreference,
  ProfilePrivacyPreferenceRequest,
  Sessions,
  UpdatePhoneRequest,
  ValidationError,
  VerifyCodeRequest,
} from '../models';
import {
    CancellationAccountFormFromJSON,
    CancellationAccountFormToJSON,
    CustomerNotificationPreferencesFromJSON,
    CustomerNotificationPreferencesToJSON,
    FreelancerNotificationPreferencesFromJSON,
    FreelancerNotificationPreferencesToJSON,
    IdentityFromJSON,
    IdentityToJSON,
    IdentityRequestFromJSON,
    IdentityRequestToJSON,
    NewEmailFormFromJSON,
    NewEmailFormToJSON,
    PasswordChangeFormFromJSON,
    PasswordChangeFormToJSON,
    PersonalInformationFromJSON,
    PersonalInformationToJSON,
    PersonalInformationRequestFromJSON,
    PersonalInformationRequestToJSON,
    PhoneFromJSON,
    PhoneToJSON,
    PhoneRequestFromJSON,
    PhoneRequestToJSON,
    PhoneValidationStatusFromJSON,
    PhoneValidationStatusToJSON,
    ProfilePrivacyPreferenceFromJSON,
    ProfilePrivacyPreferenceToJSON,
    ProfilePrivacyPreferenceRequestFromJSON,
    ProfilePrivacyPreferenceRequestToJSON,
    SessionsFromJSON,
    SessionsToJSON,
    UpdatePhoneRequestFromJSON,
    UpdatePhoneRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
    VerifyCodeRequestFromJSON,
    VerifyCodeRequestToJSON,
} from '../models';

export interface CancelAccountRequest {
    cancellationAccountForm: CancellationAccountForm;
}

export interface ChangeEmailRequest {
    newEmailForm: NewEmailForm;
}

export interface ChangeIdentityRequest {
    identityRequest: IdentityRequest;
}

export interface ChangePasswordRequest {
    passwordChangeForm: PasswordChangeForm;
}

export interface ChangePersonalInformationRequest {
    personalInformationRequest: PersonalInformationRequest;
}

export interface ChangePhoneNumberRequest {
    phoneRequest: PhoneRequest;
}

export interface ChangeProfilePrivacyPreferenceRequest {
    profilePrivacyPreferenceRequest: ProfilePrivacyPreferenceRequest;
}

export interface GetSessionsRequest {
    accountId?: string;
}

export interface UpdateCustomerNotificationPreferencesRequest {
    customerNotificationPreferences: CustomerNotificationPreferences;
}

export interface UpdateFreelancerNotificationPreferencesRequest {
    freelancerNotificationPreferences: FreelancerNotificationPreferences;
}

export interface UpdatePhoneNumberRequest {
    updatePhoneRequest: UpdatePhoneRequest;
}

export interface VerifyCodeOperationRequest {
    verifyCodeRequest: VerifyCodeRequest;
}

/**
 * 
 */
export class AccountResourceApi extends runtime.BaseAPI {

    /**
          */
    async cancelAccountRaw(requestParameters: CancelAccountRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['cancellationAccountForm'] == null) {
            throw new runtime.RequiredError(
                'cancellationAccountForm',
                'Required parameter "cancellationAccountForm" was null or undefined when calling cancelAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/cancellation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancellationAccountFormToJSON(requestParameters['cancellationAccountForm']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async cancelAccount(requestParameters: CancelAccountRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelAccountRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changeEmailRaw(requestParameters: ChangeEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['newEmailForm'] == null) {
            throw new runtime.RequiredError(
                'newEmailForm',
                'Required parameter "newEmailForm" was null or undefined when calling changeEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewEmailFormToJSON(requestParameters['newEmailForm']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changeEmail(requestParameters: ChangeEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changeEmailRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changeIdentityRaw(requestParameters: ChangeIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['identityRequest'] == null) {
            throw new runtime.RequiredError(
                'identityRequest',
                'Required parameter "identityRequest" was null or undefined when calling changeIdentity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/identity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityRequestToJSON(requestParameters['identityRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changeIdentity(requestParameters: ChangeIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changeIdentityRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['passwordChangeForm'] == null) {
            throw new runtime.RequiredError(
                'passwordChangeForm',
                'Required parameter "passwordChangeForm" was null or undefined when calling changePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordChangeFormToJSON(requestParameters['passwordChangeForm']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changePassword(requestParameters: ChangePasswordRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changePasswordRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changePersonalInformationRaw(requestParameters: ChangePersonalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['personalInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'personalInformationRequest',
                'Required parameter "personalInformationRequest" was null or undefined when calling changePersonalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/personal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PersonalInformationRequestToJSON(requestParameters['personalInformationRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changePersonalInformation(requestParameters: ChangePersonalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changePersonalInformationRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changePhoneNumberRaw(requestParameters: ChangePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['phoneRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneRequest',
                'Required parameter "phoneRequest" was null or undefined when calling changePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/phone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneRequestToJSON(requestParameters['phoneRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changePhoneNumber(requestParameters: ChangePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changePhoneNumberRaw(requestParameters, initOverrides);
    }

    /**
          */
    async changeProfilePrivacyPreferenceRaw(requestParameters: ChangeProfilePrivacyPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profilePrivacyPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'profilePrivacyPreferenceRequest',
                'Required parameter "profilePrivacyPreferenceRequest" was null or undefined when calling changeProfilePrivacyPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/privacy/profile-preference`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProfilePrivacyPreferenceRequestToJSON(requestParameters['profilePrivacyPreferenceRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changeProfilePrivacyPreference(requestParameters: ChangeProfilePrivacyPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changeProfilePrivacyPreferenceRaw(requestParameters, initOverrides);
    }

    /**
          */
    async getCustomerNotificationPreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CustomerNotificationPreferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CustomerNotificationPreferences>({
            path: `/account/api/notifications-preferences/customer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CustomerNotificationPreferencesFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCustomerNotificationPreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CustomerNotificationPreferences> {
        const response = await this.getCustomerNotificationPreferencesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerNotificationPreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerNotificationPreferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerNotificationPreferences>({
            path: `/account/api/notifications-preferences/freelancer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerNotificationPreferencesFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFreelancerNotificationPreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerNotificationPreferences> {
        const response = await this.getFreelancerNotificationPreferencesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getIdentityRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Identity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Identity>({
            path: `/account/api/identity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=IdentityFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getIdentity(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Identity> {
        const response = await this.getIdentityRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getPersonalInformationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PersonalInformation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PersonalInformation>({
            path: `/account/api/personal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PersonalInformationFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPersonalInformation(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PersonalInformation> {
        const response = await this.getPersonalInformationRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getPhoneRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Phone>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Phone>({
            path: `/account/api/phone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PhoneFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPhone(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Phone> {
        const response = await this.getPhoneRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getPhoneValidationStatusRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PhoneValidationStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PhoneValidationStatus>({
            path: `/account/api/phone/validation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PhoneValidationStatusFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPhoneValidationStatus(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PhoneValidationStatus> {
        const response = await this.getPhoneValidationStatusRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getProfilePrivacyPreferenceRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfilePrivacyPreference>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfilePrivacyPreference>({
            path: `/account/api/privacy/profile-preference`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfilePrivacyPreferenceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getProfilePrivacyPreference(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfilePrivacyPreference> {
        const response = await this.getProfilePrivacyPreferenceRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getSessionsRaw(requestParameters: GetSessionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Sessions>> {
        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['accountId'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Sessions>({
            path: `/account/api/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SessionsFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getSessions(requestParameters: GetSessionsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Sessions> {
        const response = await this.getSessionsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async resendEmailVerificationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/email/resend-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async resendEmailVerificationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.resendEmailVerificationCodeRaw(initOverrides);
    }

    /**
          */
    async resendPhoneVerificationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/phone-number/resend-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async resendPhoneVerificationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.resendPhoneVerificationCodeRaw(initOverrides);
    }

    /**
          */
    async updateCustomerNotificationPreferencesRaw(requestParameters: UpdateCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['customerNotificationPreferences'] == null) {
            throw new runtime.RequiredError(
                'customerNotificationPreferences',
                'Required parameter "customerNotificationPreferences" was null or undefined when calling updateCustomerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/notifications-preferences/customer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerNotificationPreferencesToJSON(requestParameters['customerNotificationPreferences']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateCustomerNotificationPreferences(requestParameters: UpdateCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerNotificationPreferencesRaw(requestParameters, initOverrides);
    }

    /**
          */
    async updateFreelancerNotificationPreferencesRaw(requestParameters: UpdateFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerNotificationPreferences'] == null) {
            throw new runtime.RequiredError(
                'freelancerNotificationPreferences',
                'Required parameter "freelancerNotificationPreferences" was null or undefined when calling updateFreelancerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/notifications-preferences/freelancer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreelancerNotificationPreferencesToJSON(requestParameters['freelancerNotificationPreferences']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateFreelancerNotificationPreferences(requestParameters: UpdateFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFreelancerNotificationPreferencesRaw(requestParameters, initOverrides);
    }

    /**
          */
    async updatePhoneNumberRaw(requestParameters: UpdatePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['updatePhoneRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePhoneRequest',
                'Required parameter "updatePhoneRequest" was null or undefined when calling updatePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/phone-number/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePhoneRequestToJSON(requestParameters['updatePhoneRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updatePhoneNumber(requestParameters: UpdatePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePhoneNumberRaw(requestParameters, initOverrides);
    }

    /**
          */
    async verifyCodeRaw(requestParameters: VerifyCodeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['verifyCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyCodeRequest',
                'Required parameter "verifyCodeRequest" was null or undefined when calling verifyCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/phone-number/verify-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyCodeRequestToJSON(requestParameters['verifyCodeRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async verifyCode(requestParameters: VerifyCodeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyCodeRaw(requestParameters, initOverrides);
    }

}
